import { axios } from '@Root/API'

export const edit = (id, payload) => {
	return axios.put(`notes/${id}`, payload)
}
